import { render, staticRenderFns } from "./VerificationCode.vue?vue&type=template&id=56dd9512&"
import script from "./VerificationCode.vue?vue&type=script&lang=js&"
export * from "./VerificationCode.vue?vue&type=script&lang=js&"
import style0 from "./VerificationCode.vue?vue&type=style&index=0&id=56dd9512&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports